// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-icons i {
  position: absolute;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  text-align: left;
}

.icon {
  padding: 10px;
  min-width: 40px;
}

.input-field {
  width: 100%;
  padding: 10px;
  text-align: center;
}

.scanningStrip {
  width: 100%;
  height: 5px;
  background: #aa1e1e;
  position: relative;
  animation: mymove 3s infinite;
}

@keyframes mymove {
  from {
    top: 0px;
  }
  to {
    top: 250px;
  }
}
.image-div {
  width: 100%;
  height: 255px;
  border: 1px solid #dee2e6;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
}

.image {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 255px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/participate-with-phone/participate-with-phone.component.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,eAAA;AAHF;;AAMA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAHF;;AAOA;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AAJJ;;AAOE;EACE;IAAM,QAAA;EAHR;EAIE;IAAI,UAAA;EADN;AACF;AAGA;EAEI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAFJ;;AAMA;EAEI,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAJJ","sourcesContent":["\n@use '../../../../assets/styles/colors' as colors;\n@use '../../../../assets/styles/bootstrap-essentials';\n\n.input-icons i {\n  position: absolute;\n}\n\n.input-icons {\n  width: 100%;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.icon {\n  padding: 10px;\n  min-width: 40px;\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px;\n  text-align: center;\n}\n\n\n.scanningStrip{\n    width: 100%;\n    height: 5px;\n    background: #aa1e1e;\n    position: relative;\n    animation: mymove 3s infinite;\n  }\n\n  @keyframes mymove {\n    from {top: 0px;}\n    to {top: 250px;}\n  }\n\n.image-div\n{\n    width:100%;\n    height:255px;\n    border:1px solid #dee2e6;\n    text-align:center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0.4;\n}\n\n\n.image\n{\n    width: auto;\n    max-width: 100%;\n    height: auto;\n    max-height: 255px;\n}\n\n\n@media (max-width: 767px) {\n\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
